// Contracts should be 'free' and can be export directly
export * from './eager/contracts';

import {
    sortResults,
    propertyUri,
    indexedPageView,
    personaResponseShape,
    distinguishedFolderId,
    targetFolderId,
    folderId,
    addressListId,
    contextProperty,
    findPeopleJsonRequest,
} from './eager/factories';

import { findPeopleOperation } from './eager/operations';

export const getEagerService = () => ({
    Factory: {
        sortResults,
        propertyUri,
        indexedPageView,
        personaResponseShape,
        distinguishedFolderId,
        targetFolderId,
        folderId,
        addressListId,
        contextProperty,
        findPeopleJsonRequest,
    },
    Operation: {
        findPeopleOperation,
    },
});

export const getServiceAsync = () =>
    import(/* webpackChunkName: "LazyOwaService" */ './lazyIndex').then(module => module.default);

export type { TFactories } from './lazyIndex';
